export const strings = {
    reportDetails: 'Proposal details',
    reportingPeriod: 'Portfolio performance period',
};
